import GalleryFolderMasterContainer from "../../container/admin/gallery-folder-master";

const GalleryFolderMaster = () => {
    return <GalleryFolderMasterContainer />;
};

export default GalleryFolderMaster;
